// extracted by mini-css-extract-plugin
export default {"Hide":"view_component_Hide__JdCPX","Clickable":"view_component_Clickable__RGDLD"};